import React,{useState, useEffect} from 'react'
import add_contract from '../assets/add_contract.svg'
import add_forecast from '../assets/add_forecast.svg'
import PopupAdd from './PopupAdd'
function ToolSummary({openPopup, setOpenPopup, setRefresh, setLoading, category, taskID, mainBudget, budget, expenses}) {
    const [contract, setContract] = useState(true);
    const [contracted, setContracted] = useState(0);
    const [forecasted, setForecasted] = useState(0);
    const [spent, setSpent] = useState(0);
    useEffect(() => {
      setContracted(mainBudget.reduce((a, b) => a + (b['Value'] || 0), 0));
      setForecasted(budget.reduce((a, b) => a + (b['Value'] || 0), 0));
      setSpent(expenses.reduce((a, b) => a + (b['Input'] || 0), 0));
    }, [])
    const addContract =()=>{
        setContract(true)
        setOpenPopup(true)
    }
    const addForecast =()=>{
        setContract(false)
        setOpenPopup(true)
    }
  return (
    <div className='summary-tool'>
    <PopupAdd 
    openPopup={openPopup} 
    setOpenPopup={setOpenPopup} 
    contract={contract} 
    setRefresh={setRefresh} 
    setLoading={setLoading}
    taskID={taskID}
    category={category}
    mainBudget={mainBudget}
    />

    <div className='summary-value-tool'>
      Contracted: <span className='value-tool' >{Math.round(contracted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
    </div>
    <span className='separator' >|</span>&nbsp;
    <div className='summary-value-tool'>
      Forecasted: <span className='value-tool' >{Math.round(forecasted).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</span>
    </div>
    <span className='separator' >|</span>&nbsp;
    <div className='summary-value-tool'>
      Actuals: <span className='value-tool' style={{color: Math.round(spent) > Math.round(forecasted) ? '#D6405B' : '#00A486'}}>
        {Math.round(spent).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
        <span style={{fontWeight: 200 }}>
          &nbsp;
           ({Math.round(spent / (forecasted ? forecasted : 1) *100)}%)
        </span>
        </span>
    </div>
    <div className="summary-button-tool">
        {/* Add Forecast */}
        <div
          className="summary-button-single-tool"
          onClick={addForecast}
        >
          <div className="summary-button-label-tool">
            <img src={add_forecast} alt="add-forecast" className="add" />
            &nbsp;Add Forecast
          </div>
        </div>

        {/* Add Contract */}
        <div
          className="summary-button-single-tool"
          style={{ background: '#00A486' }}
          onClick={addContract}
        >
          <div className="summary-button-label-tool">
            <img src={add_forecast} alt="add-contract" className="add" />
            &nbsp;Add Contract
          </div>
        </div>
      </div>
  </div>
  )
}

export default ToolSummary